export default "__VITE_ASSET__DzPNzLzy__"